


































































































































import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import Jitsi from "../../../ext-lib/jitsi-meet";
import { JitsiApi, JitsiParticpant } from "../../../interfaces/jitsiApi";
import { JitsiConfiguration } from "./jitsiConfiguration";
import WidgetBase from "../WidgetBase.vue";
import { User } from "../../../interfaces/user";

@Component
export default class JitsiWidget extends WidgetBase<JitsiConfiguration> {
    public static get type() {
        return "jitsi";
    }
    @Emit() public studioAttributesChanged(conferenceActive: boolean) {
        return { conferenceActive: conferenceActive };
    }

    @Prop() widgetHeight!: number;

    jitsiready: boolean = false;
    jitsiParticipantsForList: JitsiParticpant[] | [] = [];
    tileViewActive: boolean = false;
    audioMuted: boolean = true;

    public api: JitsiApi | null = null;

    public static get thumbnailAsset() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return require("@/assets/widget-thumbnails/video-call.svg");
    }

    public static static: boolean = true;

    public get userInfo(): User | null {
        return this.$store.state.user;
    }
    public get isPresenter(): boolean {
        if (!this.$store.state.studio && this.$store.state.user) {
            return true;
        } else {
            return this.$store.getters.isPresenter;
        }
    }

    public get conferenceStarted(): boolean {
        return this.$store.state.studio?.attributes.conferenceActive || false;
    }

    public get room() {
        if (this.$store.state.studio) {
            return this.$store.state.studio.studioId;
        } else return this.$store.state.user.id;
    }

    public get catBG() {
        return require(`@/assets/widget-thumbnails/cat.svg`);
    }

    public get selectedParticipant(): JitsiParticpant | null {
        return this.config.state.selectedParticipant || null;
    }

    public set selectedParticipant(newValue: JitsiParticpant | null) {
        if (this.isPresenter) {
            this.update({
                config: this.config,
                payload: { selectedParticipant: newValue },
            });
        }
    }

    public get participants(): number | null {
        return this.$store.state.studio?.attributes.participants;
    }
    public get participantLimit(): number | null {
        // TODO implement limit per user/company
        return 20;
    }
    public setJitsiParticipantsInfo() {
        this.jitsiParticipantsForList = this.api?.getParticipantsInfo() || [];
    }

    @Watch("config.state.selectedParticipant")
    public changeLargeVideo() {
        if (this.tileViewActive) {
            this.api?.executeCommand("toggleTileView");
            this.tileViewActive = !this.tileViewActive;
        }
        this.api?.setLargeVideoParticipant(
            this.selectedParticipant?.participantId
        );
    }
    public async mounted() {
        if (this.isPresenter) {
            this.createApi();
        }
        if (this.conferenceStarted && !this.api) {
            await this.createApi();
        }
        this.audioMuted = await this.api?.isAudioMuted();
    }

    public lobby(e: Event) {
        if (this.api) {
            this.api.executeCommand("toggleLobby", e);
        }
    }

    public beforeDestroy() {
        this.closeApi();
    }

    @Watch("config.state.room")
    public onRoomChange() {
        if (!this.conferenceStarted && this.isPresenter) {
            if (this.api) {
                this.closeApi();
            }

            this.createApi();
        }
    }

    @Watch("conferenceStarted")
    public onStart(startConferenceNewValue: boolean) {
        if (!this.api && startConferenceNewValue) {
            this.createApi();
        }
        // if presenter sends hangup signal, destroy api
        else if (this.api && !this.isPresenter) {
            this.closeApi();
        }
    }

    public async createApi() {
        if (!this.userInfo) {
            return;
        }
        const api = new Jitsi(this.config.state.domain, {
            userInfo: {
                email: this.userInfo.email,
                displayName: this.userInfo.displayname,
            },
            roomName: this.room,
            parentNode: this.$refs.meet as HTMLElement,
            configOverwrite: {
                disableResponsiveTiles: true,
                prejoinPageEnabled: true,
                apiLogLevels: ["warn"],
                disableDeepLinking: true,
                startWithAudioMuted: true,
                p2p: { enabled: false },
                localRecording: { enabled: true },
                desktopSharingFrameRate: { min: 20, max: 60 },
                toolbarButtons: [
                    "camera",
                    "closedcaptions",
                    "desktop",
                    "filmstrip",
                    "fullscreen",
                    "microphone",
                    "mute-everyone",
                    "mute-video-everyone",
                    "participants-pane",
                    "profile",
                    "raisehand",
                    "security",
                    "select-background",
                    "settings",
                    "shareaudio",
                    "sharedvideo",
                    "shortcuts",
                    "stats",
                    "tileview",
                    "toggle-camera",
                    "videoquality",
                    "__end",
                ],
            },
            interfaceConfigOverwrite: {
                SHARING_FEATURES: [],
                SETTINGS_SECTIONS: [
                    "devices",
                    "language",
                    "moderator",
                    "profile",
                    "calendar",
                    "sounds",
                ],
            },
        });
        api.executeCommand("subject", " ");
        api.on("participantRoleChanged", () => {
            this.jitsiready = true;
        });
        api.on("tileViewChanged", (e: { enabled: boolean }) => {
            this.tileViewActive = e.enabled;
        });
        api.on("audioMuteStatusChanged", (e: { muted: boolean }) => {
            this.audioMuted = e.muted;
        });
        this.api = api;
    }

    public closeApi() {
        if (this.api) {
            this.api.dispose();
            this.api = null;
        }
    }
}
